<!-- eslint-disable vue/multi-word-component-names, vue/no-mutating-props -->
<!-- no-mutating-props: form/consent are reactive MODEL objects owned by the
     core GateBlock; presentational SFCs cannot hold state, so two-way binding
     mutates the passed model by design. -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  gate: {
    title?: string;
    sub_title?: string;
    description?: string;
    namePlaceholder?: string;
    emailPlaceholder?: string;
    nameError?: string;
    emailError?: string;
    usePhone?: boolean;
    useEmail?: boolean;
    cta?: string;
    loading?: string;
    image?: string;
    consent_checkbox?: { text: string; required?: boolean };
  };
  quiz: { skip?: boolean; skip_cta?: string };
  form: { name: string; email: string; phone?: string };
  consent: { checked: boolean };
  fetching: boolean;
}>();
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="tpl-utua__gate">
    <div class="tpl-utua__gate-icon">
      <img v-if="gate.image" :src="gate.image" :alt="gate.title" />
      <svg v-else viewBox="0 0 20 20" aria-hidden="true">
        <path
          fill-rule="evenodd"
          d="M2.5 4A1.5 1.5 0 001 5.5V6h18v-.5A1.5 1.5 0 0017.5 4h-15zM19 8.5H1v6A1.5 1.5 0 002.5 16h15a1.5 1.5 0 001.5-1.5v-6zM3 13.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5h-1.5a.75.75 0 01-.75-.75zm4.75-.75a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5h-3.5z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <h2 class="tpl-utua__gate-title">{{ gate.title }}</h2>
    <p v-if="gate.sub_title" class="tpl-utua__gate-sub">{{ gate.sub_title }}</p>
    <p v-if="gate.description" class="tpl-utua__gate-desc">{{ gate.description }}</p>

    <form class="tpl-utua__gate-form" @submit.prevent="$emit('submit')">
      <input
        type="text"
        name="name"
        class="tpl-utua__input"
        :placeholder="gate.namePlaceholder"
        :aria-label="gate.namePlaceholder"
        :title="gate.nameError"
        required
        minlength="3"
        v-model="form.name"
      />
      <input
        v-if="gate.usePhone"
        type="tel"
        name="phone"
        class="tpl-utua__input"
        placeholder="Digite seu telefone"
        aria-label="Digite seu telefone"
        required
        v-model="form.phone"
      />
      <input
        v-if="gate.useEmail"
        type="email"
        name="email"
        class="tpl-utua__input"
        :placeholder="gate.emailPlaceholder"
        :aria-label="gate.emailPlaceholder"
        :title="gate.emailError"
        required
        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
        v-model="form.email"
      />

      <label v-if="gate.consent_checkbox" class="tpl-utua__consent">
        <input
          type="checkbox"
          name="consent"
          :required="gate.consent_checkbox.required !== false"
          v-model="consent.checked"
        />
        <span>{{ gate.consent_checkbox.text }}</span>
      </label>

      <button type="submit" class="tpl-utua__cta" :disabled="fetching">
        <span v-if="!fetching">{{ gate.cta }}</span>
        <span v-else>{{ gate.loading || '...' }}</span>
      </button>

      <button
        v-if="quiz.skip && quiz.skip_cta"
        type="button"
        class="tpl-utua__skip"
        :disabled="fetching"
        @click="$emit('skip')"
      >
        {{ quiz.skip_cta }}
      </button>
    </form>
  </div>
</template>
